import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppChallengeUserPage } from './app-challenge-user';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppChallengeUserPage,
  ],
  imports: [
    IonicPageModule.forChild(AppChallengeUserPage),
    PipesModule,
    DirectivesModule,
  ],
})
export class AppChallengeUserPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-user/app-challenge-user.module.ts